function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "spd_svg__b",
  x1: "63.84%",
  x2: "24.03%",
  y1: "13.67%",
  y2: "117.35%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5AFFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#6E96FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "52%",
  stopColor: "#FF7832"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#2800C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00004B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "spd_svg__e",
  x1: "75.79%",
  x2: "35.98%",
  y1: "-17.31%",
  y2: "86.37%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5AFFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#6E96FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "52%",
  stopColor: "#FF7832"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#2800C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00004B"
})), /*#__PURE__*/React.createElement("path", {
  id: "spd_svg__a",
  d: "M.076 3.421c0 3.718 12.907 2.794 15.1 7.95a8.8 8.8 0 00.316-2.34c0-4.835-4.062-8.985-9.24-8.985C2.218.046.076 1.972.076 3.42"
}), /*#__PURE__*/React.createElement("path", {
  id: "spd_svg__d",
  d: "M.051 2.404c0 4.836 4.062 8.985 9.24 8.985 4.034 0 6.175-1.926 6.175-3.375C15.466 4.296 2.56 5.22.366.065a8.809 8.809 0 00-.315 2.339"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.455 7)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "spd_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#spd_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#spd_svg__b)",
  fillRule: "nonzero",
  d: "M19.52 1.63L13.33 16.6-3.95 9.78 2.24-5.18z",
  mask: "url(#spd_svg__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 13.545)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "spd_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#spd_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#spd_svg__e)",
  fillRule: "nonzero",
  d: "M19.49 1.65L13.3 16.62-3.98 9.8 2.21-5.16z",
  mask: "url(#spd_svg__f)"
})));

function SvgSpd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "ca5f47ad7b84c3b14c6cce6b6ee28e52.svg";
export { SvgSpd as ReactComponent };